import React, { HTMLAttributes, useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';

import cn from 'classnames';

export interface ISliderWithThumbnailsProps
  extends HTMLAttributes<HTMLElement> {
  images: { alt: string; src: string }[];
  sliderClassname?: string;
}
const SliderWithThumbnails: React.FC<ISliderWithThumbnailsProps> = ({
  images,
  sliderClassname,
  ...props
}) => {
  const [mainSlider, setMainSlider] = useState<Slider | null>(null);
  const [secondarySlider, setSecondarySlider] = useState<Slider | null>(null);
  const mainSliderRef = useRef<Slider | null>(null);
  const secondarySliderRef = useRef<Slider | null>(null);

  useEffect(() => {
    setMainSlider(mainSliderRef.current);
    setSecondarySlider(secondarySliderRef.current);
  }, []);

  return (
    <div {...props}>
      <Slider
        adaptiveHeight
        className="mb-3"
        asNavFor={secondarySlider || undefined}
        ref={slider => {
          mainSliderRef.current = slider;
        }}
      >
        {images.map(image => (
          <div
            key={image.src}
            className="d-flex flex-column justify-content-center cursor-pointer"
          >
            <img
              className={cn('d-block w-100', sliderClassname)}
              src={image.src}
              alt={image.alt}
            />
          </div>
        ))}
      </Slider>
      {images.length > 1 && (
        <Slider
          asNavFor={mainSlider || undefined}
          ref={slider => {
            secondarySliderRef.current = slider;
          }}
          className="mx-n2"
          slidesToShow={images.length < 3 ? images.length : 3}
          swipeToSlide
          focusOnSelect
        >
          {images.map(image => (
            <div
              key={image.src}
              className="d-flex flex-column justify-content-center px-2 cursor-pointer"
            >
              <img
                className="w-100 d-block h-100 object-fit-cover"
                src={image.src}
                alt={image.alt}
              />
            </div>
          ))}
        </Slider>
      )}
    </div>
  );
};

export default SliderWithThumbnails;
